import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Table } from 'reactstrap'

import style from './style'

const PaymentType = ['withdraw', 'payment']

const StatusType = ['pending', 'canceled', 'completed']

export class Transactions extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      transations: [
        {
          date: new Date(),
          amount: 2.5,
          /*
            0 - withdraw
            1 - payment
          */
          type: 0,
          /*
            0 - pending
            1 - canceled
            2 - completed
          */
          status: 2
        }
      ]
    }
  }

  render () {
    return (
      <Row>
        <Col>
          <Table responsive className={css(style.table.table)}>
            <thead>
              <tr>
                <th className={css(style.table.th)}>Date</th>
                <th className={css(style.table.th)}>Amount</th>
                <th className={css(style.table.th)}>Type</th>
                <th className={css(style.table.th)}>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.transations.map((item, index) => (
                <RenderTableRow key={index} {...item} />
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    )
  }
}

const RenderTableRow = props => {
  const date = {
    day: props.date.getUTCDate(),
    month: props.date.getUTCMonth() + 1,
    year: props.date.getUTCFullYear()
  }

  return (
    <tr className={css(style.table.tr)}>
      <td className={css(style.table.td)}>
        <span>{`${date.day}/${date.month}/${date.year}`}</span>
      </td>
      <td className={css(style.table.td)}>
        <span>${props.amount.toFixed(2)}</span>
      </td>
      <td className={css(style.table.td)}>
        <span className={css(style.main.payment)}>
          {PaymentType[props.type]}
        </span>
      </td>
      <td className={css(style.table.td)}>
        <span
          className={css(
            style.status.label,
            style.status[StatusType[props.status]]
          )}
        >
          {StatusType[props.status]}
        </span>
      </td>
    </tr>
  )
}

export default Transactions



// WEBPACK FOOTER //
// ./src/components/Transactions/index.js